import { buyerInfoAdReplySchema, adReplySchema } from '../../models/adReply/morph.js';
import { buyerInfoAdReply, adReply } from '../../models/adReply/zod.js';
import { conversationIDSchema, unreadMessagesSchema, sendFirstContactSchema } from '../../models/messaging/morph.js';
import { conversationID, authToken, messagingMessageResponse, uploadMessageAttachments, messagingTriggerActionsResponse, startTransactionResponse, unreadMessages, channelInfo, ongoingTransactionsResponse, reportUserReasonsResponse, sendFirstContactResponse } from '../../models/messaging/zod.js';
import { clientGet, clientPost, clientDelete, clientPut, clientPostForm } from '../../utils/fetchwrapper.js';
import { processBody, returnStatus } from '../../utils/fetchwrapperUtils/responseProcessors.js';

const getBuyerInfo = (origin, userID) => clientGet({
    url: `${origin}/v1/reply/users/${userID}/info`,
}).then(processBody(buyerInfoAdReplySchema, buyerInfoAdReply));
const sendAdReply = (origin, adID, body, buyerInfo, attachment) => {
    const req = {
        accept_terms_conds: true,
        name: buyerInfo.name,
        phone: buyerInfo.phone,
        forward_phone: buyerInfo.forwardPhone,
        body,
    };
    if (attachment) {
        const data = new FormData();
        data.append('request', new Blob([JSON.stringify(req)], {
            type: 'application/json',
        }), 'request');
        data.append('attach', attachment);
        return clientPostForm({ url: `${origin}/v1/reply/${adID}` }, data).then(processBody(adReplySchema, adReply));
    }
    else {
        return clientPost({ url: `${origin}/v1/reply/${adID}` }, req).then(processBody(adReplySchema, adReply));
    }
};
const getConversationID = (origin, userID, partnerID, itemID) => clientGet({
    url: `${origin}/v1/mcproxy/api/hal/${userID}/conversations?partnerId=${partnerID}&itemId=${itemID}&itemType=ad`,
}).then(processBody(conversationIDSchema, conversationID));
const getChatAuthToken = (origin, userID, timeout) => clientPost({
    url: `${origin}/v1/chat/users/${userID}/auth/token`,
    timeoutMs: timeout,
}).then(processBody(null, authToken));
//remove when the Stream post rollout is finished(new messaging)
const sendMessageToMessaging = (origin, userID, conversationID, body) => clientPost({
    url: `${origin}/v1/mcproxy/api/hal/${userID}/conversations/${conversationID}/messages`,
}, body).then(processBody(null, messagingMessageResponse));
const uploadMessagingAttachment = (origin, channelID, attachment) => {
    const formData = new FormData();
    formData.append('file', attachment);
    return clientPostForm({
        url: `${origin}/v1/chat/channel/${channelID}/attachment`,
    }, formData).then(processBody(null, uploadMessageAttachments));
};
const getTriggerActions = (origin, userID, channelID) => clientGet({
    url: `${origin}/v1/chat/users/${userID}/channel/${channelID}/triggers`,
}).then(processBody(null, messagingTriggerActionsResponse));
const startTransaction = (origin, userID, body) => clientPost({
    url: `${origin}/v1/chat/users/${userID}/transactions`,
}, body).then(processBody(null, startTransactionResponse));
const getUnreadMessages = (origin, userID) => clientGet({
    url: `${origin}/v1/chat/messages/${userID}/unread`,
}).then(processBody(unreadMessagesSchema, unreadMessages));
const getChannelInfo = (origin, userID, adID, peerID) => clientGet({
    url: `${origin}/v1/chat/users/${userID}/channel?ad_id=${adID}&peer_id=${peerID}`,
}).then(processBody(null, channelInfo));
const getOngoingTransactions = (origin, userID, peerID, adID) => {
    const params = new URLSearchParams({ peer_id: peerID });
    if (adID) {
        params.append('ad_id', adID);
    }
    return clientGet({
        url: `${origin}/v1/chat/users/${userID}/transactions/ongoing?${params.toString()}`,
    }).then(processBody(null, ongoingTransactionsResponse));
};
const reportUser = (origin, userID, body) => clientPost({
    url: `${origin}/v1/chat/users/${userID}/report`,
}, body).then(returnStatus);
const getReportUserReasons = (origin, userID) => clientGet({
    url: `${origin}/v1/chat/users/${userID}/report/reasons`,
}).then(processBody(null, reportUserReasonsResponse));
const blockUser = (origin, userID, blockedUserID) => clientPost({
    url: `${origin}/v1/chat/users/${userID}/block/${blockedUserID}`,
}).then(returnStatus);
const unblockUser = (origin, userID, blockedUserID) => clientDelete({
    url: `${origin}/v1/chat/users/${userID}/block/${blockedUserID}`,
}).then(returnStatus);
const sendFirstContact = (origin, adID, userID, body, buyerInfo, attachment) => {
    const url = `${origin}/v1/chat/users/${userID}/adreply/${adID}`;
    const data = {
        accept_terms_conds: true,
        name: buyerInfo.name,
        phone: buyerInfo.phone,
        forward_phone: buyerInfo.forwardPhone,
        body,
    };
    if (attachment) {
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(data)], {
            type: 'application/json',
        }), 'request');
        formData.append('attach', attachment);
        return clientPostForm({ url }, formData).then(processBody(sendFirstContactSchema, sendFirstContactResponse));
    }
    return clientPost({ url }, data).then(processBody(sendFirstContactSchema, sendFirstContactResponse));
};
const updateAdInfo = (origin, userID, channelID, body) => clientPut({
    url: `${origin}/v1/chat/users/${userID}/adinfo/${channelID}`,
}, body).then(returnStatus);

export { blockUser, getBuyerInfo, getChannelInfo, getChatAuthToken, getConversationID, getOngoingTransactions, getReportUserReasons, getTriggerActions, getUnreadMessages, reportUser, sendAdReply, sendFirstContact, sendMessageToMessaging, startTransaction, unblockUser, updateAdInfo, uploadMessagingAttachment };
//# sourceMappingURL=client.js.map
